/**
 * Returns the confirmation message to display in prompt before clearing the
 * SearchCompanies select field.
 * @param {string} vendorOrCustomerText
 * @return {string}
 */
export const getClearCompanyConfirmationText = (vendorOrCustomerText) =>
  `By clicking confirm, you will lose all progress creating this ${vendorOrCustomerText}, including any contacts you have added.`;
